<template lang="html">
<div>
  <b-table
    :data="traces"
    :default-sort="defaultSort"
    :default-sort-direction="defaultSortDirection"
    :sort-icon="sortIcon"
    :sort-icon-size="sortIconSize"
    :sticky-header="stickyHeaders"
    :mobile-cards="mobileCards"
    :height="tableHeight">

    <template slot-scope="props">
      <b-table-column field="id"
                      label="ID"
                      width="3ch"
                      numeric>
        {{ props.row.id }}
      </b-table-column>

      <b-table-column field="short_name"
                      label="Name"
                      width="10ch"
                      :sortable="showUser"
                      :visible="showUser">
        {{ props.row.user.short_name }}
      </b-table-column>

      <b-table-column field="description"
                      label="Description"
                      searchable>
        {{ props.row.description }}
      </b-table-column>

      <!-- Must provide custom-key if no label. -->
      <b-table-column custom-key="edit-description"
                      :visible="editable"
                      width="4ch">
        <b-button class="is-small is-light"
                  @click="editTrace(props.row)">
          <b-icon icon="edit" size="is-small"></b-icon>
        </b-button>
      </b-table-column>

      <b-table-column field="created"
                      label="Date"
                      width="10ch"
                      sortable
                      centered>
        {{ new Date(props.row.created).toLocaleDateString() }}
      </b-table-column>

      <!-- Sorting here is on the underlying date-time string. -->
      <b-table-column field="created"
                      label="Time"
                      width="10ch"
                      centered>
        {{ new Date(props.row.created).toLocaleTimeString() }}
      </b-table-column>

      <!-- Must provide custom-key if no label. -->
      <b-table-column custom-key="delete"
                      :visible="editable"
                      width="4ch">
        <b-button class="is-small is-danger"
                  @click="deleteTrace(props.row)">
          <b-icon icon="trash" size="is-small"></b-icon>
        </b-button>
      </b-table-column>
    </template>
  </b-table>

</div>
</template>

<script>
import Trace from '@/models/Trace'
import TraceEditForm from './TraceEditForm'
import api from '@/utils/api'

export default {
  props: {
    user_id: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    },
    showUser: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      defaultSort: 'created',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      stickyHeaders: true,
      mobileCards: true,
      tableHeight: '500px'
    }
  },
  computed: {
    traces () {
      return Trace.query()
        .where('user_id', this.user_id)
        .with('user').get()
    }
  },
  methods: {
    editTrace (trace) {
      this.$buefy.modal.open({
        parent: this,
        component: TraceEditForm,
        hasModalCard: false,
        trapFocus: true,
        props: {
          trace: trace
        }
      })
    },
    deleteTrace (trace) {
      api.deleteTrace(trace)
        .catch((response) => {
          api.showApiErrorDialog(this, response)
        })
    }
  }
}
</script>
